// extracted by mini-css-extract-plugin
export var SectionWrapper = "Form-module--SectionWrapper--JkaPc";
export var ImageWrapper = "Form-module--ImageWrapper--2tea7";
export var Form = "Form-module--Form--3mZRE";
export var Input = "Form-module--Input--GFkJe";
export var InputError = "Form-module--InputError--2lYnb";
export var InputErrorMessage = "Form-module--InputErrorMessage--3rR6p";